import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Label, Media, Row } from "reactstrap"
import ApiRest from "../../ayudas/apiRest"
import { SOLICITUD_ESTADOS } from "../../ayudas/constantes"
import _valid from "../../validations"


export default class ProyectoSolicitudInformacion extends Component {
    constructor(props) {
        super(props);
        this.apiRest = new ApiRest(props);
        this.state = {
            idRegistro: props.props,
            registro: _valid(props.datos) && props.datos.registro,
            datos: [],
            colapsar: true
        };
    }

    componentDidMount() {
        /* NECESITAMOS EL ID DE SOLICITUD O LOS DATOS DE LA SOLICITUD */
        const { idRegistro, registro } = this.state;

        if (_valid(idRegistro)) {
            this.apiRest.getWithFiles('/solicitud/' + idRegistro).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ registro: resultado.data });
                }
            });
        }
        if (_valid(registro.odoo_id)) {
            this.apiRest.get('/solicitud_odoo/' + registro.odoo_id).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ datos: resultado.data });                
                }
            });
        }
    }

    render() {
        const { registro, datos, colapsar } = this.state;
        return (
            <React.Fragment>
                <Card style={(registro.odoo_id && (registro.odoo16_id === null)) ? {background: "#FED2BD"}:{}}>
                    <CardBody>
                        <Link onClick={() => this.setState({ colapsar: !colapsar })} className="text-dark" to="#">
                            <Media className="d-flex align-items-center">
                                <div className="me-3">
                                    <i className="uil uil-receipt text-primary h2"></i>
                                </div>
                                <div className="flex-1 overflow-hidden">
                                    <h5 className="font-size-16 mb-1">Datos de Asignaci&oacute;n</h5>
                                </div>
                                <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                            </Media>
                        </Link>
                        <hr />
                        {
                            _valid(registro) &&
                            <Collapse isOpen={colapsar}>
                                {
                                    (registro.odoo_id && (registro.odoo16_id === null)) ? (
                                        <Row>
                                            <Col lg={6}>
                                                <div className="mb-3 mb-4">
                                                    <Label className="form-label">
                                                        Número Ticket Odoo (Corporativo)
                                                    </Label>
                                                    <p>
                                                        {datos.id}
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col lg={6}>
                                                <div className="mb-3 mb-4">
                                                    <Label className="form-label">
                                                        Estado Ticket Odoo
                                                    </Label>
                                                    <p>
                                                        {datos.stage_id}
                                                    </p>
                                                </div>
                                            </Col>
                                            { (datos.user_id) ? (
                                            <Col lg={6}>
                                                <div className="mb-3 mb-4">
                                                    <Label htmlFor="colaborador" className="form-label">
                                                        Asignado al colaborador
                                                    </Label>
                                                    <p>
                                                        {datos.user_id}
                                                    </p>
                                                </div>
                                            </Col>
                                            ) : ''}
                                            { (datos.close_date) ? (
                                            <Col lg={6}>
                                                <div className="mb-3 mb-4">
                                                    <Label htmlFor="colaborador" className="form-label">
                                                        Fecha de cierre
                                                    </Label>
                                                    <p>
                                                        {datos.close_date}
                                                    </p>
                                                </div>
                                            </Col>
                                            ) : ''}
                                            { (datos.x_new_field_PD26356622008083064) ? (
                                            <Col lg={6}>
                                                <div className="mb-3 mb-4">
                                                    <Label htmlFor="colaborador" className="form-label">
                                                        Motivo del rechazo
                                                    </Label>
                                                    <p>
                                                        {datos.x_new_field_PD26356622008083064}
                                                    </p>
                                                </div>
                                            </Col>
                                            ) : ''}
                                        </Row>
                                    )
                                    :
                                    (
                                        <div>
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="mb-3 mb-4">
                                                        <Label className="form-label">
                                                            Nombre del proyecto
                                                        </Label>
                                                        <p>
                                                            {registro.proyecto_nombre}
                                                        </p>
                                                    </div>
                                                </Col>
                                                <Col lg={6}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="colaborador" className="form-label">
                                                            Asignado a (Colaborador)
                                                        </Label>
                                                        <p>
                                                            {registro.colaborador_nombre}
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="estado" className="form-label">
                                                            Estado
                                                        </Label>
                                                        <p>
                                                            {SOLICITUD_ESTADOS[registro.estado].label}
                                                        </p>
                                                    </div>
                                                </Col>
                                                <Col lg={6}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="fechaMin" className="form-label">
                                                            Desde la fecha
                                                        </Label>
                                                        <p>
                                                            {registro.fecha_programada}
                                                        </p>
                                                    </div>
                                                </Col>
                                                <Col lg={6}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="fechaFin" className="form-label">
                                                            Hasta la fecha
                                                        </Label>
                                                        <p>
                                                            {registro.fecha_fin}
                                                        </p>
                                                    </div>
                                                </Col>
                                                <Col lg={2}>
                                                    <div className="mb-3 mb-4">
                                                        <Label
                                                            htmlFor="horas"
                                                            className="form-label"
                                                        >
                                                            Horas programadas
                                                        </Label>
                                                        <p>
                                                            {registro.horas}
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    )
                                }

                                
                            </Collapse>
                        }
                    </CardBody>
                </Card>
            </React.Fragment >
        )
    }
}